import { urlsWrapper } from 'config';
import {
  saveData,
  createCommonListConstants,
  createCommonListReducer,
} from './utils';
import { commonGet } from './api';

const constants = createCommonListConstants('ADVISOR_USERS');

// reducer
export default createCommonListReducer(constants);

// actions
export function getAdvisorUsersList() {
  return saveData(
    urlsWrapper('advisorUsers'),
    constants.SET_LIST,
    constants.SET_IS_PENDING
  );
}

export const getBayerTsCustomers = () =>
  commonGet({
    url: `${urlsWrapper('bayerTsCustomers')}`,
  });

export const getBayerTsCustomer = (id) =>
  commonGet({
    url: `${urlsWrapper('bayerTsCustomers')}/${id}`,
  });

export const getAvailableAdvisorUsers = () =>
  commonGet({
    url: `${urlsWrapper('availableadvisorusers')}`,
  });

// selector
export const getAdvisorUsersSelector = (state) => state.advisorUsers;

const shouldFetchSeeds = (state) => state.advisorUsers.list.length === 0;

export const fetchAdvisorUsersIfNeeded = () => (dispatch, getState) => {
  const state = getState();
  return shouldFetchSeeds(state)
    ? dispatch(getAdvisorUsersList())
    : Promise.resolve();
};
